import React from 'react';

import COLORS from '../../../../constants/colors.constants';

export const Tooltip = ({
  id,
  children,
  left,
  top,
  isShown = false,
}) => (
  <div
    id={id}
    className="absolute border border-border-darkest p-2 shadow rounded flex"
    style={{
      left,
      top,
      backgroundColor: COLORS.chart.background.tooltip,
      opacity: isShown ? 1 : 0,
    }}
  >
    { children }
  </div>
)

export default Tooltip;
